import styled, { css } from 'styled-components';

import colors from 'utils/colors';
import device from 'utils/device';

import { TextProps } from './interfaces';

export const TaskButtonIconWrapper = styled.div`
  transition: all 0.5s ease-out;
  width: 15px;
  height: 15px;
  padding-right: 8px;

  svg {
    transition: all 0.5s ease-out;
  }
`;

export const TextWrapper = styled.div`
  transition: all 0.5s ease-out;
  height: 24px;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.3px;
  text-align: center;
  word-break: keep-all;
  color: ${colors.blueGrey};

  @media ${device.isDesktop}, ${device.isTablet} {
    height: 24px;
    letter-spacing: -0.3px;
  }
`;

export const TaskButtonWrapper = styled.button<TextProps>`
  transition: all 0.5s ease-out;
  display: flex;
  justify-content: ${props => (props.styleType === 'largeWithBorder' ? 'center' : 'flex-start')};
  align-items: center;
  text-decoration: none;
  font-family: VIC;
  box-sizing: border-box;
  vertical-align: middle;
  word-break: break-all;
  flex-wrap: nowrap;
  cursor: pointer;
  border-radius: 2px;
  background-color: ${colors.white};
  border: ${props =>
    props.styleType === 'largeWithBorder' ? `1px solid ${colors.blueGrey}` : 'none'};
  width: 100%;
  height: 50px;
  padding-left: ${props => (props.styleType === 'largeWithBorder' ? '16px' : '4px')};
  padding-right: 16px;

  ${props =>
    props.disabled
      ? css`
          div {
            color: ${colors.darkGrey75};
          }

          svg {
            &.add {
              stroke: ${colors.darkGrey75};
            }

            &.change,
            &.delete,
            &.download,
            &.cancel {
              fill: ${colors.darkGrey75};
            }
          }
        `
      : css`
          ${
            props.styleType === 'largeWithBorder'
              ? `
          :hover {
            border-color: ${colors.orange};
          }
        `
              : null
          }

          :hover div,
            :focus div {
            color: ${colors.orange};

            .add {
              stroke: ${colors.orange};
            }

            .change,
            .delete,
            .download,
            .cancel {
              fill: ${colors.orange};
            }
          }
        `}

  @media ${device.isDesktop}, ${device.isTablet} {
    max-width: 350px;
  }
`;
